import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./contactSocial.scss";


import InstagramIcon from "../../../assets/contact/intagram.png";
import YoutubeIcons from "../../../assets/contact/youtube.png";
import LnkdnIcon from "../../../assets/contact/lnkdn.png";


const contactSocial = () => (
<Row>
  <Col xs={12}>
    <Row center="xs">
      <Col xs={12} lg={1} className="contact__social">
        <a href="https://www.linkedin.com/company/mediatrixmaroc" target="_blank" rel="noopener noreferrer">
          <img  src={LnkdnIcon} alt="Facebook" style={{ width: "30px", height: "30px" }}/>
        </a>
      </Col>
      <Col xs={12} lg={1} className="contact__social">
        <a href="https://www.instagram.com/mediatrixagency/" target="_blank" rel="noopener noreferrer">
          <img src={InstagramIcon} alt="Twitter" style={{ width: "30px", height: "30px" }}/>
        </a>
      </Col>
      <Col xs={12} lg={1} className="contact__social">
        <a href="https://www.youtube.com/channel/UCXxU6QQHA4RTNW4mDusAWcw" target="_blank" rel="noopener noreferrer">
          <img src={YoutubeIcons} alt="Dribbble" style={{ width: "30px", height: "30px" }}/>
        </a>
      </Col>
    </Row>
  </Col>
</Row>

);

export default contactSocial;
